

export default [
  {
    url: '/',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  // {
  //   url: '/dashboard/mitra-baznas',
  //   name: 'Mitra Baznas',
  //   icon: 'GlobeIcon',
  //   i18n: 'Mitra Baznas'
  // },
  {
    url: '/dashboard/levels',
    name: 'Levels',
    icon: 'UserCheckIcon',
    i18n: 'Levels'
  },
  {
    url: '/dashboard/kategori-sos',
    name: 'Kategori SOS',
    icon: 'TruckIcon',
    i18n: 'Kategori SOS'
  },
  {
    url: '/dashboard/ppob/set-range-harga',
    name: 'Set Range Harga PPOB',
    icon: 'GridIcon',
    i18n: 'Set Range Harga PPOB'
  },
  {
    url: '/dashboard/sos',
    name: 'SOS',
    icon: 'TruckIcon',
    i18n: 'SOS'
  },
  {
    url: '/dashboard/news',
    name: 'News',
    icon: 'FileTextIcon',
    i18n: 'News'
  },
  {
    url: '/dashboard/roles',
    name: 'Roles',
    icon: 'UserPlusIcon',
    i18n: 'Roles'
  },
  {
    url: '/dashboard/menus',
    name: 'Menus',
    icon: 'ServerIcon',
    i18n: 'Menu'
  },
  {
    url: '/dashboard/users',
    name: 'Users',
    icon: 'UsersIcon',
    i18n: 'Users'
  },
  {
    url: '/dashboard/banner',
    name: 'Banner',
    icon: 'SquareIcon',
    i18n: 'Banner'
  },
  {
    url: '/dashboard/metode-pembayaran',
    name: 'Metode Pembayaran',
    icon: 'PocketIcon',
    i18n: 'Metode Pembayaran'
  },
  {
    url: '/dashboard/jenis-transaksi',
    name: 'Jenis Transaksi',
    icon: 'PocketIcon',
    i18n: 'Jenis Transaksi'
  },
  {
    url: '/dashboard/kategori-penyaluran',
    name: 'Kategori Penyaluran',
    icon: 'PocketIcon',
    i18n: 'Kategori Penyaluran'
  },
  {
    url: '/dashboard/sahabat-zx',
    name: 'Sahabat ZX',
    icon: 'BriefcaseIcon',
    i18n: 'Sahabat ZX'
  },
  {
    url: '/dashboard/transaksi',
    name: 'Riwayat Transaksi',
    icon: 'ArrowUpCircleIcon',
    i18n: 'Riwayat Transaksi'
  },
  {
    url: '/dashboard/banner-donasi',
    name: 'Banner Donasi',
    icon: 'SquareIcon',
    i18n: 'Banner Donasi'
  },
  {
    url: '/dashboard/qurban',
    name: 'Qurban',
    icon: 'GitlabIcon',
    i18n: 'Qurban'
  },
  {
    url: '/dashboard/banner-ppob',
    name: 'Banner PPOB',
    icon: 'SquareIcon',
    i18n: 'Banner PPOB'
  },
  {
    url: '/dashboard/about',
    name: 'About Setting',
    icon: 'MenuIcon',
    i18n: 'About Setting'
  },
  {
    url: '/dashboard/referal',
    name: 'Referal',
    icon: 'ColumnsIcon',
    i18n: 'Referal'
  },
  // {
  //   url: '/dashboard/wilayah',
  //   name: 'Wilayah',
  //   icon: 'CompassIcon',
  //   i18n: 'Wilayah'
  // },
  // {
  //   url: '/dashboard/term-and-condition-setting',
  //   name: 'Term & Condition Setting',
  //   icon: 'FileIcon',
  //   i18n: 'Term & Condition Setting'
  // },
  {
    url: '/dashboard/campaign',
    name: 'Campaign',
    icon: 'LayersIcon',
    i18n: 'Campaign'
  },
  {
    url: '/dashboard/aproval-sos',
    name: 'Aproval SOS',
    icon: 'RadioIcon',
    i18n: 'Aproval SOS'
  },
  {
    url: '/dashboard/penyaluran-dana',
    name: 'Penyaluran Dana',
    icon: 'ArrowUpRightIcon',
    i18n: 'Penyaluran Dana'
  },
  {
    url: '/dashboard/aproval-campaign',
    name: 'Aproval Campaign',
    icon: 'LayersIcon',
    i18n: 'Aproval Campaign'
  },
  {
    url: '/dashboard/kategori-campaign',
    name: 'Kategori Campaign',
    icon: 'LayersIcon',
    i18n: 'Kategori Campaign'
  },
  {
    url: '/dashboard/medsos',
    name: 'Media Sosial',
    icon: 'FacebookIcon',
    i18n: 'Media Sosial'
  },
  {
    url: '/dashboard/kontak',
    name: 'Kontak',
    icon: 'HeadphonesIcon',
    i18n: 'Kontak'
  },
  // {
  //   url: '/dashboard/sub-kategori-campaign',
  //   name: 'Sub Kategori Campaign',
  //   icon: 'LayersIcon',
  //   i18n: 'Sub Kategori Campaign'
  // },
  {
    url: '/dashboard/aproval-penerima-dana',
    name: 'Aproval Penerima Dana',
    icon: 'CreditCardIcon',
    i18n: 'Aproval Penerima Dana'
  },
  {
    url: '/dashboard/zis/kategori',
    name: 'Kategori ZIS',
    icon: 'GridIcon',
    i18n: 'Kategori ZIS'
  },
  {
    url: '/dashboard/zakat-fitrah',
    name: 'Zakat Fitrah',
    icon: 'PocketIcon',
    i18n: 'Zakat Fitrah'
  },
  {
    url: '/dashboard/tutorial-pembayaran',
    name: 'Tutorial Pembayaran',
    icon: 'ListIcon',
    i18n: 'Tutorial Pembayaran'
  },
  {
    url: '/dashboard/setting-root-icon',
    name: 'Setting Root Icon',
    icon: 'CircleIcon',
    i18n: 'Setting Root Icon'
  },
  {
    url: '/dashboard/custom-nominal-zis',
    name: 'Custom Nominal ZIS',
    icon: 'PocketIcon',
    i18n: 'Custom Nominal ZIS'
  },
  {
    url: '/dashboard/sahabat-zx/pendapatan',
    name: 'Pendapatan',
    icon: 'BarChart2Icon',
    i18n: 'Pendapatan'
  },
  {
    url: '/dashboard/version-update',
    name: 'Versi Update Mobile',
    icon: 'PocketIcon',
    i18n: 'Versi Update Mobile'
  },
  {
    url: '/dashboard/journal/kode-akun',
    name: 'Kode Akun',
    icon: 'TrendingUpIcon',
    i18n: 'Kode Akun'
  },
  {
    url: '/dashboard/journal/setting-journal',
    name: 'Setting Journal',
    icon: 'TrendingUpIcon',
    i18n: 'Setting Journal'
  },
  {
    url: '/dashboard/penyaluran/aproval',
    name: 'Aproval Penyaluran',
    icon: 'ChevronsDownIcon',
    i18n: 'Aproval Penyaluran'
  },
  {
    url: '/dashboard/journal/pembagian',
    name: 'Journal Pembagian',
    icon: 'TrendingUpIcon',
    i18n: 'Journal Pembagian'
  },
  {
    url: '/dashboard/journal/master-journal',
    name: 'Master Journal',
    icon: 'TrendingUpIcon',
    i18n: 'Master Journal'
  },
  {
    url: '/dashboard/syarat-sos',
    name: 'Syarat SOS',
    icon: 'FileTextIcon',
    i18n: 'Syarat SOS'
  }
]

